import chroma from 'chroma-js';
import Radium from 'radium';
import React from 'react';

const style = (backgroundColor, width = 'auto') => ({
  fontSize: 16,
  fontWeight: 500,
  border: '1px solid #222',
  color: 'white',
  display: 'inline-block',
  backgroundColor,
  borderRadius: 5,
  padding: '0 16px',
  margin: '8px',
  height: 36,
  lineHeight: '36px',
  outline: 'none',
  textDecoration: 'none',
  textTransform: 'uppercase',
  transition: 'background-color 0.2s',
  whiteSpace: 'nowrap',
  width,
  ':active': {
    backgroundColor: chroma(backgroundColor).darken(5).hex(),
  },
});

@Radium
export default class HeaderButton extends React.Component {
  render() {
    const Element = this.props.element || 'button';
    const backgroundColor = this.props.backgroundColor || '#5bbae9';
    return (
      <Element
        type="button"
        style={[
          style(backgroundColor, this.props.width),
          this.props.disabled && { backgroundColor: '#ddd' },
        ]}
        {...this.props} />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./ui/_HeaderButton.jsx
 **/